import React from 'react';
import { onScroll } from '@/hooks/paging';
import TasksFilters from './TasksFilters';
import TasksPanelContainer from './TasksPanelContainer';
import TaskCards from './TaskCards';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const TasksPanelNarrow = ({ category, onChange, url }) => {
  const state = Selectors.useTasksPanel({ category });
  const fetchData = Events.useFetchRequestTasks(category);

  return (
    <TasksPanelContainer
      category={category}
      className="aridhia-tasks-panel-narrow"
      compact
      onChange={onChange}
      url={url}
    >
      <div className="sticky-panel-header">
        <TasksFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <TaskCards
        allowDatasetLink={state.allowDatasetLink}
        allowRequestLink={state.allowRequestLink}
        canEdit={state.canEdit}
        category={category}
        email={state.email}
        handleScroll={() => onScroll(fetchData, state)}
        items={state.tasks}
        itemsPerRow={1}
        readErrors={state.readErrors}
        readStatus={state.readStatus}
      />
    </TasksPanelContainer>
  );
};

export default TasksPanelNarrow;
